/**
 * Maps a menu item href to the path prefixes of its child routes.
 *
 * When the current route path starts with any listed prefix,
 * the parent menu link is highlighted as active via `is-active`.
 *
 * Populate entries here as parent-child relationships are defined.
 * Format:
 *   '/parent/path': ['/child/path-prefix', '/another/child-prefix']
 */
export const ROUTE_CHILDREN_MAP = {
  '/clt/consultar': [
    '/clt/novo',
  ],
  '/clt/contratos': [
    '/clt/detalhes-do-contrato',
  ],
  '/fgts/consultar': [
    '/fgts/novo',
    '/fgts/consultar/lote',
    '/fgts/consultar/lote/historico',
  ],
  '/cgv/propostas': [
    '/cgv/detalhes-proposta/:proposal_id',
    '/cgv/atualizar-proposta/:proposal_id',
  ],
  '/cgv/consultar': [
    '/cgv/simulacao',
    '/cgv/formalizacao',
  ],
  '/cartao/proposta': [
    '/cartao/proposta/:proposal_id',
  ],
};
